
import { verify, resendVerification } from '@/services/email';

const state = {

};

const getters = {

};

const actions = {
  async requestVerify({ commit }, token) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response = null;
    try {
      response = await verify(token);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: err.message, errorCode: err.code }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
  async requestResendVerification({ commit }, email) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response;
    try {
      response = await resendVerification(email);
    } catch (err) {
      // eslint-disable-next-line max-len
      // commit('NotificationModule/SET_STATUS', { status: 400, message: err.data.message, errorCode: err.status }, { root: true });
      throw err.data;
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
};

const mutations = {

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Email/index.js